export const FIRST_MONTH_FREE = 'firstmonthfree'
